const fonts = {
  fonts: {
    body: 'Muli, sans-serif',
    heading: 'Muli, sans-serif',
  },
  fontSizes: [
    '12px', // 0
    '14px', // 1
    '15px', // 2
    '16px', // 3
    '18px', // 4
    '20px', // 5
    '24px', // 6
    '28px', // 7
    '30px', // 8
    '36px', // 9
    '40px', // 10
    '65px', // 11
    '80px', // 12
    '95px', // 13
  ],
  fontWeights: {
    thin: 100,
    extraLight: 200,
    light: 300,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    extraBold: 800,
    black: 900,
  },
};

export default fonts
